import Phaser from "phaser";
import mon001 from "@assets/imgs/monsters/001-008/001-sea-mon.png";
import mon001_dead from "@assets/imgs/monsters/001-008/001-sea-mon-dead.png";
import mon002 from "@assets/imgs/monsters/001-008/002-desert-mon.png";
import mon002_dead from "@assets/imgs/monsters/001-008/002-desert-mon-dead.png";
import mon003 from "@assets/imgs/monsters/001-008/003-sea-mon.png";
import mon003_dead from "@assets/imgs/monsters/001-008/003-sea-mon-dead.png";
import mon004 from "@assets/imgs/monsters/001-008/004-desert-mon.png";
import mon004_dead from "@assets/imgs/monsters/001-008/004-desert-mon-dead.png";
import mon005 from "@assets/imgs/monsters/001-008/005-sea-mon.png";
import mon005_dead from "@assets/imgs/monsters/001-008/005-sea-mon-dead.png";
import mon006 from "@assets/imgs/monsters/001-008/006-desert-mon.png";
import mon006_dead from "@assets/imgs/monsters/001-008/006-desert-mon-dead.png";
import mon007 from "@assets/imgs/monsters/001-008/007-sea-mon.png";
import mon007_dead from "@assets/imgs/monsters/001-008/007-sea-mon-dead.png";
import mon008 from "@assets/imgs/monsters/001-008/008-desert-mon.png";
import mon008_dead from "@assets/imgs/monsters/001-008/008-desert-mon-dead.png";
import mon009 from "@assets/imgs/monsters/009-016/009-forest-mon.png";
import mon009_dead from "@assets/imgs/monsters/009-016/009-forest-mon-dead.png";
import mon010 from "@assets/imgs/monsters/009-016/010-factory-mon.png";
import mon010_dead from "@assets/imgs/monsters/009-016/010-factory-mon-dead.png";
import mon011 from "@assets/imgs/monsters/009-016/011-forest-mon.png";
import mon011_dead from "@assets/imgs/monsters/009-016/011-forest-mon-dead.png";
import mon012 from "@assets/imgs/monsters/009-016/012-factory-mon.png";
import mon012_dead from "@assets/imgs/monsters/009-016/012-factory-mon-dead.png";
import mon013 from "@assets/imgs/monsters/009-016/013-forest-mon.png";
import mon013_dead from "@assets/imgs/monsters/009-016/013-forest-mon-dead.png";
import mon014 from "@assets/imgs/monsters/009-016/014-factory-mon.png";
import mon014_dead from "@assets/imgs/monsters/009-016/014-factory-mon-dead.png";
import mon015 from "@assets/imgs/monsters/009-016/015-forest-mon.png";
import mon015_dead from "@assets/imgs/monsters/009-016/015-forest-mon-dead.png";
import mon016 from "@assets/imgs/monsters/009-016/016-factory-mon.png";
import mon016_dead from "@assets/imgs/monsters/009-016/016-factory-mon-dead.png";

/** 분류 + 서식지 타입 */
export type HabitatType = "SEA" | "DESERT" | "FOREST" | "FACTORY";

/** 몬스터 설정 */
export interface MonsterConfig {
  id: string;
  textureKey: string;
  habitat: HabitatType; // 이 몬스터가 속한 타입 (분류 + 도감 겸용)
  minSpawnScore: number; // 등장 최소 점수
}

/** 전체 몬스터 목록 */
export const MONSTERS: MonsterConfig[] = [
  {
    id: "mon-001",
    textureKey: "001-sea-mon",
    habitat: "SEA",
    minSpawnScore: 0,
  },
  {
    id: "mon-002",
    textureKey: "002-desert-mon",
    habitat: "DESERT",
    minSpawnScore: 0,
  },
  {
    id: "mon-003",
    textureKey: "003-sea-mon",
    habitat: "SEA",
    minSpawnScore: 300,
  },
  {
    id: "mon-004",
    textureKey: "004-desert-mon",
    habitat: "DESERT",
    minSpawnScore: 300,
  },
  {
    id: "mon-005",
    textureKey: "005-sea-mon",
    habitat: "SEA",
    minSpawnScore: 800,
  },
  {
    id: "mon-006",
    textureKey: "006-desert-mon",
    habitat: "DESERT",
    minSpawnScore: 800,
  },
  {
    id: "mon-007",
    textureKey: "007-sea-mon",
    habitat: "SEA",
    minSpawnScore: 1500,
  },
  {
    id: "mon-008",
    textureKey: "008-desert-mon",
    habitat: "DESERT",
    minSpawnScore: 1500,
  },
  {
    id: "mon-009",
    textureKey: "009-forest-mon",
    habitat: "FOREST",
    minSpawnScore: 0,
  },
  {
    id: "mon-010",
    textureKey: "010-factory-mon",
    habitat: "FACTORY",
    minSpawnScore: 0,
  },
  {
    id: "mon-011",
    textureKey: "011-forest-mon",
    habitat: "FOREST",
    minSpawnScore: 300,
  },
  {
    id: "mon-012",
    textureKey: "012-factory-mon",
    habitat: "FACTORY",
    minSpawnScore: 300,
  },
  {
    id: "mon-013",
    textureKey: "013-forest-mon",
    habitat: "FOREST",
    minSpawnScore: 800,
  },
  {
    id: "mon-014",
    textureKey: "014-factory-mon",
    habitat: "FACTORY",
    minSpawnScore: 800,
  },
  {
    id: "mon-015",
    textureKey: "015-forest-mon",
    habitat: "FOREST",
    minSpawnScore: 1500,
  },
  {
    id: "mon-016",
    textureKey: "016-factory-mon",
    habitat: "FACTORY",
    minSpawnScore: 1500,
  },
];

/** 스테이지 설정 (얼음 vs 사막) */
export interface StageConfig {
  id: string;
  // name: string;
  leftHabitat: HabitatType; // 왼쪽 버튼 / 왼쪽 바구니
  rightHabitat: HabitatType; // 오른쪽 버튼 / 오른쪽 바구니
  obstacleIds: string[];
}

/** 에셋 로딩 */
export function preloadMonsters(scene: Phaser.Scene) {
  scene.load.image("001-sea-mon", mon001);
  scene.load.image("001-sea-mon-dead", mon001_dead);
  scene.load.image("002-desert-mon", mon002);
  scene.load.image("002-desert-mon-dead", mon002_dead);
  scene.load.image("003-sea-mon", mon003);
  scene.load.image("003-sea-mon-dead", mon003_dead);
  scene.load.image("004-desert-mon", mon004);
  scene.load.image("004-desert-mon-dead", mon004_dead);
  scene.load.image("005-sea-mon", mon005);
  scene.load.image("005-sea-mon-dead", mon005_dead);
  scene.load.image("006-desert-mon", mon006);
  scene.load.image("006-desert-mon-dead", mon006_dead);
  scene.load.image("007-sea-mon", mon007);
  scene.load.image("007-sea-mon-dead", mon007_dead);
  scene.load.image("008-desert-mon", mon008);
  scene.load.image("008-desert-mon-dead", mon008_dead);
  scene.load.image("009-forest-mon", mon009);
  scene.load.image("009-forest-mon-dead", mon009_dead);
  scene.load.image("010-factory-mon", mon010);
  scene.load.image("010-factory-mon-dead", mon010_dead);
  scene.load.image("011-forest-mon", mon011);
  scene.load.image("011-forest-mon-dead", mon011_dead);
  scene.load.image("012-factory-mon", mon012);
  scene.load.image("012-factory-mon-dead", mon012_dead);
  scene.load.image("013-forest-mon", mon013);
  scene.load.image("013-forest-mon-dead", mon013_dead);
  scene.load.image("014-factory-mon", mon014);
  scene.load.image("014-factory-mon-dead", mon014_dead);
  scene.load.image("015-forest-mon", mon015);
  scene.load.image("015-forest-mon-dead", mon015_dead);
  scene.load.image("016-factory-mon", mon016);
  scene.load.image("016-factory-mon-dead", mon016_dead);
}

/** 이 스테이지에서 등장할 몬스터 풀 */
export function getMonstersForStage(stage: StageConfig): MonsterConfig[] {
  return MONSTERS.filter(
    (m) => m.habitat === stage.leftHabitat || m.habitat === stage.rightHabitat,
  );
}

/** 도감용: 특정 타입(ICE/ DESERT)에 속한 몬스터들 */
export function getMonstersByHabitat(habitat: HabitatType): MonsterConfig[] {
  return MONSTERS.filter((m) => m.habitat === habitat);
}

// 도감용: id로 몬스터 정보 조회 (발견한 몬스터 상세보기)
export function getMonsterById(id: string): MonsterConfig {
  const monster = MONSTERS.find((m) => m.id === id);

  if (!monster) {
    throw new Error(`Monster not found: ${id}`);
  }

  return monster;
}

// 전체 몬스터 목록 반환
export function getAllMonsters(): MonsterConfig[] {
  return [...MONSTERS];
}
